<template>
    <RouterView v-slot="{ Component }">
        <component :is="Component" :dashboard-api-base="dashboardApiBase"></component>
    </RouterView>
</template>

<script setup>
import { RouterView } from 'vue-router';
import { useRestaurantsListStore } from '../../stores/restaurant-list-store';

const props = defineProps({
    concepts: { type: Array, required: true },
    restaurants: { type: Array, required: true },
    dashboardApiBase: { type: String, required: true },
});

const store = useRestaurantsListStore();

const { setConcepts, setRestaurants } = store;

setConcepts(props.concepts);
setRestaurants(props.restaurants);
</script>
